// Moved from `src/hooks/mutation/useMutateDeleteTeamEntitlement.ts` (now a
// re-export delegate) with the EN4 mutation slice (ARCFE-1025). Verbatim —
// see `useMutateAssignTeamEntitlement.ts` for why this slice needs no port.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type components } from '@heidi/schema/ml-scribe';

import {
  GET_TEAM_ACCESS_ENTITLEMENTS,
  GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS,
} from '../../contracts';
import { deleteTeamEntitlementAsTeamAdmin } from '../api/entitlements';

export type DeleteTeamEntitlementAsTeamAdminVariables = {
  teamId: string;
  body: components['schemas']['DeleteUserAccessEntitlementRequest'];
};

/**
 * DELETE /api/v2/ml-scribe/access-entitlements/team/{team_id}
 * Soft-delete a team-level access entitlement. Caller must be a team admin.
 */
export function useMutateDeleteTeamEntitlement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ teamId, body }: DeleteTeamEntitlementAsTeamAdminVariables) => {
      const { data } = await deleteTeamEntitlementAsTeamAdmin(teamId, body);
      return data;
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [GET_TEAM_ACCESS_ENTITLEMENTS, variables.teamId],
      });
      void queryClient.invalidateQueries({
        queryKey: [GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS, variables.teamId],
      });
    },
  });
}
